import ConstructionPage from "@components/pages/constructionPage/ConstructionPage";
import ErrorPage from "@components/pages/errorPage/ErrorPage";
import { config } from "@utils/config";
import { Routes, Route } from "react-router-dom";

type Props = {
  children: React.ReactNode | React.ReactNode[];
};

const RoutesWrapper = ({ children }: Props) => (
  <Routes>
    {config.isUnderConstruction ? (
      <Route path="*" element={<ConstructionPage />} />
    ) : (
      <>{children}</>
    )}
    <Route path="*" element={<ErrorPage error={404} />} />
  </Routes>
);

export default RoutesWrapper;
